<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful title="My Profile :: MeritEHS" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item active"><i class="fa fa-user"></i> My Profile</li>
                </ol>
            </h4>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4">
                <b-nav-item :active="curTab === 'general'" @click="curTab = 'general'">
                    General Info
                </b-nav-item>
                <b-nav-item :active="curTab === 'reminders'" @click="curTab = 'reminders'">
                    Inspection Goals
                </b-nav-item>
                <b-nav-item :active="curTab === 'logins'" @click="curTab = 'logins'">
                    Alternative Logins
                </b-nav-item>
            </ul>

            <div v-if="curTab === 'general'">
                <div class="row">
                    <div class="col-xl-8 col-lg-12">
                        <div class="card mb-3">
                            <div class="card-header"><strong>Basic Details</strong></div>
                            <div class="card-body">
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.FirstName }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">First Name:</label>
                                    <div class="col-sm-8">
                                        <input type="text" name="FirstName" v-model="user.FirstName" class="form-control" placeholder="Enter First Name (Required)" />
                                        <span v-if="errors.FirstName" class="text-danger">
                                            <span v-for="error in errors.FirstName">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.LastName }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Last Name:</label>
                                    <div class="col-sm-8">
                                        <input type="text" name="LastName" v-model="user.LastName" class="form-control" placeholder="Enter Last Name (Required)" />
                                        <span v-if="errors.LastName" class="text-danger">
                                            <span v-for="error in errors.LastName">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.email }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Email:</label>
                                    <div class="col-sm-8">
                                        <input type="text" name="email" :value="user.email" class="form-control" placeholder="Enter Position" disabled="disabled" />
                                        <span v-if="errors.email" emailclass="text-danger">
                                            <span v-for="error in errors.email">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <hr/>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.timezone_slug }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Timezone</label>
                                    <div class="col-sm-8">
                                        <select v-model="user.timezone_slug" class="form-control">
                                            <option :value="undefined">-- Select a Timezone --</option>
                                            <option v-for="timezone in timezones" :value="timezone.zone_slug">
                                                {{ timezone.display_name }}
                                            </option>
                                        </select>
                                        <span v-if="errors.timezone_slug" class="text-danger">
                                            <span v-for="error in errors.timezone_slug">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.pinned_sidebar }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Pin Sidebar <i class="fa fa-question-circle" title="If checked, the sidebar will always stay visible on your screen and will scroll separately from the page."></i></label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="user.pinned_sidebar" :value="1" :unchecked-value="0" plain />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header"><strong>Change Password</strong></div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Current Password:</label>
                                    <div class="col-sm-8">
                                        <input type="password" name="current_password" v-model="password.existing" class="form-control" autocomplete="new-password" placeholder="Enter Current Password" />
                                        <div><small>Current Password is required to set a new password.</small></div>
                                        <span v-if="errors.password" class="text-danger">
                                            <span v-for="error in errors.password">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <hr/>

                                <div class="form-group row">
                                    <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.new_password }">New Password:</label>
                                    <div class="col-sm-8">
                                        <input type="password" name="new_password" v-model="password.new_password" :class="{ 'form-control': true, 'is-invalid': errors.new_password }" placeholder="Enter New Password" />
                                        <span v-if="errors.new_password" class="text-danger">
                                            <span v-for="error in errors.new_password">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Confirm New Password:</label>
                                    <div class="col-sm-8">
                                        <input type="password" v-model="password.new_password_confirmation" :class="{ 'form-control': true, 'is-invalid': errors.new_password_confirmation }" placeholder="Confirm New Password" />
                                        <span v-if="errors.new_password_confirmation" class="text-danger">
                                            <span v-for="error in errors.new_password_confirmation">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-12">
                        <div class="card mb-3">
                            <div class="card-header"><strong>Your Current Roles</strong></div>
                            <div class="card-body">
                                <ul>
                                    <li v-for="role in currentRoles">{{ role.name }}</li>
                                </ul>
                                <hr/>
                                <router-link to="/profile/request-roles" class="btn btn-sm btn-info">
                                    <i class="fa fa-envelope"></i> Request Roles
                                </router-link>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header"><strong>Current Jobsite</strong></div>
                            <div class="card-body">
                                <p v-if="user.current_jobsite_id">
                                    <template v-if="$store.state.user.permissions.length > 0 || !$store.state.user.subcontractor_id">
                                        <router-link :to="`jobsites/view/${user.current_jobsite_id}`">
                                            {{ user.JobsiteNumber }} - {{ user.JobsiteName }}
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        {{ user.JobsiteNumber }} - {{ user.JobsiteName }}
                                    </template>
                                </p>
                                <p v-else>
                                    --
                                </p>
                                <hr/>
                                <router-link v-if="$store.state.user.permissions.length > 0 || !$store.state.user.subcontractor_id" to="/profile/jobsite" class="btn btn-sm btn-success">
                                    <i class="fa fa-building"></i> Set Current Jobsite <i class="fa fa-caret-right"></i>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="curTab === 'reminders'">
                <div class="card mb-3">
                    <div class="card-header">
                        <strong>My Inspection Goals</strong>
                        <router-link to="/profile/reminders/edit" class="btn btn-sm btn-success ml-3"><i class="fa fa-plus-circle"></i> Create</router-link>
                    </div>
                    <div class="card-body">
                        <inspection-goal-list></inspection-goal-list>
                    </div>
                </div>
            </div>
            <div v-if="curTab === 'logins'">
                <one-click-login></one-click-login>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="saveProfile()" :disabled="saving">Update</button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                user: {},
                password: {},
                timezones: {},
                errors: {},
                roles: [],
                curTab: 'general',
                userTimezone: this.$store.state.user.timezone,
            }
        },

        computed: {
            currentRoles(){
                let currentRoles = [];

                for(var i in this.roles)
                {
                    if(this.roles[i].hasRole == 1)
                    {
                        currentRoles.push(this.roles[i]);
                    }
                }

                return currentRoles;
            }
        },

        methods: {
            // Convert database timezone/format to human
            readTime(time) {
                return moment(time, 'HH:mm:ss').tz(this.userTimezone).format('LT');
            },

            //Get the Various Resources We Need to Edit an User
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            deleteReminder: function(reminder_id) {
                if (!confirm('Are you sure you want to delete this reminder?'))
                {
                    return;
                }

                this.$http
                .post(`/profile/reminders/delete/${reminder_id}`, {})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Reminder Deleted');

                    this.$refs.remindersTable.refresh();
                })
            },

            getProfile: function() {
                //Get the data
                this.$http
                    .get('profile')
                    .then(response => {
                        //Set all the data
                        this.user = response.data.user;
                        this.timezones = response.data.timezones;
                        this.roles = response.data.roles;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveProfile: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //SEt the password values
                this.user.password = this.password.existing;
                this.user.new_password = this.password.new_password;
                this.user.new_password_confirmation = this.password.new_password_confirmation;

                //Send it
                this.$http
                .post('profile', this.user)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Profile Saved');

                    //Update the store
                    this.$store.commit('login', response.data);

                    //Reset the password
                    this.password = {};

                    //Return to main list?
                    this.$router.go();
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getProfile();
        }
    }
</script>
